module.exports = __webpack_public_path__ + "img/sld_star_delta_transformer_h_l1_dark.5e76803c.svg";